import { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useActiveData } from '@hooks/useActiveData'
import { claimRecordsApi } from '@redux/queries/claimRecords'
import { connectorOrderComplete } from '@redux/slices/connectorSlice'
import { logger } from '@utils/logger'

export const useOrderCompleteEventHandler = (): (() => void) => {
  const dispatch = useDispatch()
  const [isInProgress, setIsInProgress] = useState(false)
  const { fetchActiveData } = useActiveData()

  return useCallback(async () => {
    if (isInProgress) return

    setIsInProgress(true)

    // verify order has been placed before reset
    try {
      const result = await fetchActiveData()
      if (!result?.id) {
        dispatch(connectorOrderComplete())
        dispatch(claimRecordsApi.util.resetApiState())
      }
    } catch (error) {
      logger.warn('Unable to verify order complete', error)
    } finally {
      setIsInProgress(false)
    }
  }, [dispatch, fetchActiveData, isInProgress])
}
